module.exports = __webpack_public_path__ + "assets/img/trace.3799653e.png";